import { ReactSelect } from "../kits/Inputs/Inputs";
import { useState, useEffect } from "react";

export default function TimePicker({ func, defaultTime = 0 }) {
  const [day, setDay] = useState([]);
  const [hour, setHour] = useState([]);
  const [minutes, setMinutes] = useState([]);
  const [date, setDate] = useState({
    day: "",
    hour: "",
    minutes: "",
    seconds: "",
  });
  const dataHandler = (object) => {
    let temp = { ...date, ...object };
    let secondsTemp = temp.day * 86400 + temp.hour * 3600 + temp.minutes * 60;
    setDate({ ...temp, seconds: secondsTemp });
    func(secondsTemp);
  };

  useEffect(() => {
    let dayTemp = [];
    let hourTemp = [];
    let minutesTemp = [];
    for (let i = 0; i < 31; i++) {
      dayTemp = [...dayTemp, { label: i, value: i }];
    }
    for (let i = 0; i < 24; i++) {
      hourTemp = [...hourTemp, { label: i, value: i }];
    }
    for (let i = 0; i < 60; i++) {
      minutesTemp = [...minutesTemp, { label: i, value: i }];
    }
    setDay(dayTemp);
    setHour(hourTemp);
    setMinutes(minutesTemp);
    let defaultDay = 0;
    let defaultHour = 0;
    let defaultMinutes = 0;
    if (defaultTime > 0) {
      defaultDay = Math.floor(defaultTime / 86400);
      defaultHour = Math.floor((defaultTime - defaultDay * 86400) / 3600);
      defaultMinutes = Math.floor(
        (defaultTime - defaultDay * 86400 - defaultHour * 3600) / 60
      );
      setDate((prev) => {
        return {
          ...prev,
          day: defaultDay,
          hour: defaultHour,
          minutes: defaultMinutes,
        };
      });
    }
    console.log(defaultDay, defaultHour, defaultMinutes);
  }, [defaultTime]);
  return (
    <div className="d-flex">
      <ReactSelect
        title="دقیقه"
        inputSize="lg"
        itemsList={minutes}
        onChangeFunc={(e) => dataHandler({ minutes: e.value })}
        inputValue={minutes.filter((v) => v.value == date.minutes)}
        style={{ width: "33.3%" }}
      />
      <ReactSelect
        title="ساعت"
        inputSize="lg"
        itemsList={hour}
        onChangeFunc={(e) => dataHandler({ hour: e.value })}
        inputValue={hour.filter((v) => v.value == date.hour)}
        style={{ width: "33.3%" }}
      />
      <ReactSelect
        title="روز"
        inputSize="lg"
        itemsList={day}
        onChangeFunc={(e) => dataHandler({ day: e.value })}
        inputValue={day.filter((v) => v.value == date.day)}
        style={{ width: "33.3%" }}
      />
    </div>
  );
}
